import { render, staticRenderFns } from "./sellproductdetails.vue?vue&type=template&id=6a219fab&"
import script from "./sellproductdetails.vue?vue&type=script&lang=js&"
export * from "./sellproductdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports